export default __webpack_public_path__ + "static/media/hand_large.0c7410a3.png";